module.exports = __webpack_public_path__ + "static/about-477cc6656592386c362b49c69f23bb2a.jpg";